import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import { StyledTeamArea } from '../sections/styles/StyledTeamArea';

const TeamPopup = ({ popupContent }) => {
  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(o => !o);
  return (
    <>
      <button className='text-button text-block-3' onClick={() => setOpen(true)}>
        Curriculum  Vitae
      </button>
      <Popup open={open} modal onClose={() => setOpen(false)}>
        <StyledTeamArea>
          <div className='team-popup-bg'></div>
          <div className='team-popup-inner-wrapper'>
            <div className='team-popup-text-wrapper'>
              <h3 className='team-popup-title'>{popupContent.name}</h3>
              <p className='team-popup-profession-text'>
                {popupContent.position} <br />
                {popupContent.specialty}
              </p>
              <div className='team-popup-text-inner-wrapper'>
                <div className='team-popup-paragraph'>
                  {popupContent.desc.map((skillList, i) => {
                    return (
                      <React.Fragment key={i}>
                        <h4>{skillList.listTitle}</h4>
                        <ul key={i}>
                          {skillList.list.map((text, listI) => <li key={listI} className="text-block-2">{text}</li>)}
                        </ul>
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className='team-popup-lines-wrapper'>
              <div className='popup-orange-line'></div>
              <div className='popup-purple-line'></div>
            </div>
            <img
              loading='lazy'
              src={popupContent.img}
              alt='drGay'
              sizes='100vw'
              srcSet={`${popupContent.img} 500w, ${popupContent.img} 750w`}
              className='team-popup-image'
            />
            <p className='team-popup-close' onClick={closeModal}>
              &times;
            </p>
          </div>
        </StyledTeamArea>
      </Popup>
    </>
  );
};

export default TeamPopup;